import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useBirthChartsDataContext } from './hooks/useBirthChartsDataContext';

export const Presentation = () => {
    const { chartData } = useBirthChartsDataContext();


    return (
        <SimpleBars
            title={'Apresentação'}
            horizontal={false}
            subtitles={chartData?.presentation?.map((item) => item.description)}
            values={chartData?.presentation?.map((item) => item.total  ||  0)}
        />
    );
};
